module.exports = __webpack_public_path__ + "assets/PatternRight.b9171e9bd69078596ed640748c0b08df.png";